import * as yup from 'yup';
import type { CustomLocale } from '../Types/Login.locale.types';
import { MIN_PASSWORD_LENGTH } from '../utils/validation.utils';

/**
 * Creates login validation schema with localized error messages
 * @param customLocale - Locale function for translations
 * @returns Yup validation schema
 */
export const createLoginSchema = (customLocale: CustomLocale) => {
  return yup.object().shape({
    email: yup
      .string()
      .required(customLocale('email.error', 'Email is required'))
      .email(customLocale('email.error', 'Please enter a valid email address'))
      .trim(),
    password: yup
      .string()
      .required(customLocale('password.error', 'Password is required'))
      .min(
        MIN_PASSWORD_LENGTH,
        customLocale(
          'password.error',
          `Password must be at least ${MIN_PASSWORD_LENGTH} characters`,
        ),
      ),
  });
};
